import React from 'react';

var SvgCheckmark = function SvgCheckmark(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14.78 3.22c.293.293.293.767 0 1.06l-8.532 8.533c-.293.293-.768.293-1.06 0q-.064-.064-.11-.137l-2.271-2.244-1.587-1.587c-.293-.293-.293-.768 0-1.06s.767-.293 1.06 0l1.586 1.585 1.863 1.84 7.99-7.99c.294-.293.768-.293 1.061 0",
    clipRule: "evenodd"
  }));
};
SvgCheckmark.displayName = "Checkmark";

export { SvgCheckmark as S };
